import actions from '../../actionTypes';

export default data => {
  return {
    type: actions.BULK_UPLOAD_FINISHED,
    data
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/bulkUploadFinished.js